import axios from "axios";
import router from "../router";
import store from "../store";
import { mustGetEnv } from "@/utils/env";

let authApiService = axios.create({
  baseURL: mustGetEnv("VUE_APP_AUTHSERVICE_BASEURL"),
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

authApiService.interceptors.request.use(function (config) {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
authApiService.interceptors.response.use(
  function (response) {
    if (
      response?.status == 200 &&
      (response?.config?.url === "/login" ||
        response?.config?.url === "/refresh-token")
      ) {
      store.commit("showLoader", false);
      localStorage.setItem("token", response?.data?.token);
      localStorage.setItem("refresh_token", response?.data?.refresh_token);
      localStorage.setItem(
        "roles",
        JSON.stringify(response?.data?.token_info?.roles ?? [])
      );
      localStorage.setItem(
        "permissions",
        JSON.stringify(response?.data?.token_info?.permissions ?? [])
      );
      localStorage.setItem(
        "company_id",
        response?.data?.token_info?.company_id
      );
      localStorage.setItem(
        "scopes",
        JSON.stringify(response?.data?.token_info?.scopes ?? [])
      );
      localStorage.setItem("user_id", response?.data?.token_info?.user_id);
      localStorage.setItem(
        "types",
        JSON.stringify(response?.data?.token_info?.types ?? {})
      );
    }
    return response;
  },
  function (error) {
    store.commit("showLoader", false);
    const responseData = error?.response?.data;

    if (
      responseData.message &&
      responseData.message ==
        "Not allowed to access the requested resource: Expired token"
    ) {
      // Clear the token and other user information
      localStorage.clear();
      NotificationService.showError("You need to relogin");
      // Redirect to login page
      router.push("/");
    }
    // if (
    //     (error?.response?.status === 401 || error?.response?.status === 419) &&
    //     error?.config?.url === "/login"
    // ) {
    //     store.dispatch("auth/refreshToken", {
    //         refresh_token: localStorage.getItem("refresh_token"),
    //     });
    // }

    if (responseData) {
      const { msg, message, errors } = responseData;

      if (msg || message) {
        if (
          responseData.message !=
          "Not allowed to access the requested ressource: Expired token"
        ) {
          store.dispatch(
            "showResponse",
            {
              type: "error",
              message: msg || message,
              errors: errors || {},
            },
            {
              root: true,
            }
          );
        }
      }
    }
    return Promise.reject(error);
  }
);

export default authApiService;
